import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../lib/utils';

export default function OverviewRollPanel({
  title,
  headerRight,
  summary,
  children,
  emptyMessage = 'No data for this period.',
  isEmpty = false,
  footer,
  className,
  scrollMaxHeightClass = 'max-h-[min(280px,36vh)]',
  showScrollHint = true,
  scrollHint = 'पॅनेलमध्ये scroll करा',
}) {
  return (
    <div className={cn('de-ultra-card flex flex-col p-4 sm:p-5', className)}>
      <div className="mb-3 flex shrink-0 flex-wrap items-center justify-between gap-2">
        <h3 className="m-0 text-sm font-bold text-de-gold">{title}</h3>
        {headerRight}
      </div>
      {summary ? <div className="mb-3 shrink-0 space-y-2">{summary}</div> : null}
      <div className="de-ultra-roll-wrap relative min-h-0">
        <div className={cn('de-ultra-roll space-y-2 pr-0.5', scrollMaxHeightClass)}>
          {isEmpty ? (
            <p className="m-0 py-8 text-center text-xs text-de-muted">{emptyMessage}</p>
          ) : (
            children
          )}
        </div>
      </div>
      {showScrollHint && !isEmpty ? (
        <p className="de-ultra-roll-hint m-0 mt-2 flex items-center justify-center gap-1 text-[10px] font-bold uppercase tracking-[0.15em] text-de-gold/45">
          <ChevronDown className="h-3 w-3 animate-bounce" aria-hidden />
          {scrollHint}
        </p>
      ) : null}
      {footer}
    </div>
  );
}
